import script from "./MRD_RT_004.vue?vue&type=script&setup=true&lang=js"
export * from "./MRD_RT_004.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__